import { render, staticRenderFns } from "./DeleteCpesToInventory.vue?vue&type=template&id=1a2cc67d&"
import script from "./DeleteCpesToInventory.vue?vue&type=script&lang=js&"
export * from "./DeleteCpesToInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports